module.exports = __webpack_public_path__ + "img/info.6cdcfe8c.svg";